import dayjs from 'dayjs';

import type { Dayjs } from 'dayjs';

export default function isDateExpired(date: Dayjs) {
  const currentDate = dayjs();
  return currentDate.isAfter(date);
}
